export async function canDecodeImageFile(file: Blob): Promise<boolean> {
  const objectUrl = URL.createObjectURL(file);
  const image = new Image();

  try {
    await new Promise<void>((resolve, reject) => {
      image.onload = () => resolve();
      image.onerror = () => reject(new Error('image decode failed'));
      image.src = objectUrl;
    });
    return image.naturalWidth > 0 || image.width > 0;
  } catch {
    return false;
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
